import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import htmlParser from "html-react-parser";
import "./Banner.css";
import LoadingSpinner from "../LoadingSpinner";

export default function Banner({ data, cdnUrl }) {
  const [progressWidth, setProgressWidth] = useState(0);
  const [starFill, setStarFill] = useState(0);
  const [reviewData, setReviewData] = useState(null);
  const [animationCycle, setAnimationCycle] = useState(0);

  useEffect(() => {
    fetch("https://resources.swmc.com/jsons/whysunwest.json")
      .then(response => response.json())
      .then(responseData => {
        setReviewData(responseData.displayData);
      })
      .catch(error => {
        console.error('Error fetching review data:', error);
        setReviewData({
          review: {
            totalReviews: "34,689",
            since: "November 1980",
            average: "4.9"
          },
          recommendation: "97.4%"
        });
      });
  }, []);

  useEffect(() => {
    if (!reviewData) return;

    const recommendationValue = parseFloat(reviewData.recommendation);
    const averageRating = parseFloat(reviewData.review.average);

    setProgressWidth(0);
    setStarFill(0);

    const progressInterval = setInterval(() => {
      setProgressWidth(prev => {
        if (prev >= recommendationValue) {
          clearInterval(progressInterval);
          return recommendationValue;
        }
        return prev + 0.5;
      });
    }, 10);

    const starInterval = setInterval(() => {
      setStarFill(prev => {
        if (prev >= averageRating) {
          clearInterval(starInterval);
          return averageRating;
        }
        return prev + 0.05;
      });
    }, 20);

    const cycleTimeout = setTimeout(() => {
      setAnimationCycle(prev => prev + 1);
    }, 4000);

    return () => {
      clearInterval(progressInterval);
      clearInterval(starInterval);
      clearTimeout(cycleTimeout);
    };
  }, [reviewData, animationCycle]);

  const Star = ({ index, fillAmount }) => {
    const fill = Math.max(0, Math.min(1, fillAmount - index));
    
    return (
      <svg width="40" height="40" viewBox="0 0 40 40" className="star-svg">
        <defs>
          <linearGradient id={`star-gradient-${index}`}>
            <stop offset={`${fill * 100}%`} stopColor="#FF5601" />
            <stop offset={`${fill * 100}%`} stopColor="#D9D9D9" />
          </linearGradient>
        </defs>
        <path
          d="M20 2L25.326 13.854L38 15.708L29 24.292L31.18 37L20 30.854L8.82 37L11 24.292L2 15.708L14.674 13.854L20 2Z"
          fill={`url(#star-gradient-${index})`}
        />
      </svg>
    );
  };

  if (!reviewData) {
    return (
      <LoadingSpinner />
    );
  }
 
  const { leftColumn, rightColumn } = data.banner;

  return (
    <section className="testimonial-banner">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} lg={6}>
            <h1 className="title-container">
              <span 
                className="title-line" 
                style={{ color: leftColumn.heading.line1Color }}
              >
                {htmlParser(leftColumn.heading.line1)}
              </span>
              <br />
              <span 
                className="title-line" 
                style={{ color: leftColumn.heading.line2Color }}
              >
                {htmlParser(leftColumn.heading.line2)}
              </span>
              <br />
              <span 
                className="title-line" 
                style={{ color: leftColumn.heading.line3Color }}
              >
                {htmlParser(leftColumn.heading.line3)}
              </span>
            </h1>
            <p className="description">
              {htmlParser(leftColumn.description)}
            </p>
          </Col>
          <Col xs={12} lg={1}></Col>
          <Col xs={12} lg={5}>
            <div className="stats-card">
              <div className="progress-container">
               
                <div className="progress-bar">
                  <div 
                    className="progress-fill"
                    style={{ width: `${progressWidth}%` }}
                  />
                </div>
                <div className="progress-label">
                  <span className="percentage-text">
                    {reviewData.recommendation}
                  </span>
                </div>
                <p className="recommend-text">
                  {htmlParser(rightColumn.recommendationText)}
                </p>
              </div>

              <div className="stars-container">
                <div className="stars-row">
                  {[0, 1, 2, 3, 4].map(i => (
                    <Star key={i} index={i} fillAmount={starFill} />
                  ))}
                </div>
                <div className="rating-text">
                  <span className="rating-number">
                    {reviewData.review.average}
                  </span>
                  <span className="rating-out-of"> out of 5</span>
                </div>
                <p className="average-text">
                  {htmlParser(rightColumn.ratingText)}
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}